import { FormsEnum, SectionsEnum } from 'app/shared/enums';
// prettier-ignore
import { setHistoryVisibilityBasedOnPersonalData } from 'app/services/businessFunctions/helpers/setHistoryVisibilityBasedOnPersonalData';

const historyVisibilityBasedOnPersonalData = {
  setOwnerHistoryVisibilityBasedOnPersonalData() {
    setHistoryVisibilityBasedOnPersonalData({
      insuranceHistorySection: SectionsEnum.OwnerInsuranceHistory,
      formName: FormsEnum.CalculationForm,
    });
  },
};

export default historyVisibilityBasedOnPersonalData;
